// extracted by mini-css-extract-plugin
export default {"buttonContainer":"UserManagementMenu_buttonContainer__5YDzu","deleteButton":"UserManagementMenu_deleteButton__E1t44"};